module.exports = __webpack_public_path__ + "static/media/image.805da932.svg";